import {Component, Inject,  OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {DataBrokerService} from '../../../core/services/data-broker/data-broker.service';
import {ImageService} from '../../../core/services/image/image.service';
import {OrganizationService} from '../../../core/services/organization/organization.service';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {OrgOverviewService} from '../../../modules/organizations/services/org-overview.service';
import {OrganizationOverview} from '../../../core/classes/organization-overview.class';
import {mergeMap} from 'rxjs/operators';

interface DialogData {
  mode: string;
  parentOrgId: string;
  organizationType: string;
}

@UntilDestroy()
@Component({
  selector: 'app-org-onboard-dialog',
  templateUrl: './org-onboard-dialog.component.html',
  styleUrls: ['./org-onboard-dialog.component.scss'],
})
export class OrgOnboardDialogComponent implements OnInit {
  public labels: {[key: string]: string};
  public isLoaded = false;
  public organization: OrganizationOverview;
  public selectedTab = 0;
  public tabList: Array<string> = [];

  constructor(
    public dialogRef: MatDialogRef<OrgOnboardDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private dataBrokerService: DataBrokerService,
    private imageService: ImageService,
    private organizationService: OrganizationService,
    private orgOverviewService: OrgOverviewService
  ) {
    const languageUpdate$ = this.dataBrokerService.subscribe('language-update');
    const createdOrg$ = this.dataBrokerService.subscribe('created-org');
    const updatedOrg$ = this.dataBrokerService.subscribe('organization-updated');

    this.updateLanguage();
    languageUpdate$.pipe(untilDestroyed(this)).subscribe(this.updateLanguage.bind(this));

    createdOrg$.pipe(untilDestroyed(this)).subscribe(this.onClose.bind(this));
    updatedOrg$.pipe(untilDestroyed(this)).subscribe(this.onClose.bind(this));
  }

  ngOnInit() {
    this.tabList = ['Organization Details'];

    this.getOrgInfo();
  }

  private getOrgInfo() {
    if (this.data.mode === 'edit') {
      this.orgOverviewService.getOrgOverview()
        .pipe(mergeMap((organization) => this.imageService.addImage(organization, 'organizationImage', 150)))
        .subscribe((org: OrganizationOverview) => {
          this.organization = org;
          this.isLoaded = true;
        });
    } else {
      this.isLoaded = true;
    }
  }

  public selectTab(index: number) {
    this.selectedTab = index;
  }

  onClose(): void {
    this.dialogRef.close();
  }

  private updateLanguage() {
    this.labels = {
      title: '',
    };
  }
}
